import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import { DATE_FORMAT } from "@/common/constant";
@Component
class DateTimeGenerator extends Vue {
  public getYears() {
    const currentYear = new Date().getFullYear();
    const result = [];
    for (let index = 1990; index <= currentYear; index++) {
      result.push(index);
    }
    return result.reverse();
  }
  public getMonths() {
    const result = [];
    for (let index = 1; index <= 12; index++) {
      result.push(index);
    }
    return result;
  }
  public getDays() {
    const result = [];
    for (let index = 1; index <= 31; index++) {
      result.push(index);
    }
    return result;
  }

  public async getDateListByChangeDate(changeDate) {
    const result = [];
    const dateOfMonth = moment(moment(changeDate).set('date', 1).format(DATE_FORMAT)).endOf("month").date();
    for (let index = 1; index <= dateOfMonth; index++) {
      result.push(index);
    }

    return result;
  }
}
export default DateTimeGenerator;
